"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowForwardIos_1 = __importDefault(require("@mui/icons-material/ArrowForwardIos"));
const People_1 = __importDefault(require("@mui/icons-material/People"));
const Support_1 = __importDefault(require("@mui/icons-material/Support"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const shallow_1 = require("zustand/shallow");
const access_1 = require("../../../../../common/constants/access");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const ContactLiveChatActive_1 = __importDefault(require("../../../../hsbc_img/img/ContactLiveChatActive"));
const StyledMenuItem_1 = require("../../../../material-ui-theme/components/styled/StyledMenuItem");
const approvalQuery_1 = require("../../../../queries/approvals/approvalQuery");
const companyQuery_1 = require("../../../../queries/companyQuery");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../zustandStore");
const iconWrapper_1 = __importStar(require("../iconWrapper"));
const createNewRequestButton_1 = __importDefault(require("./createNewRequestButton"));
const styledComponents_1 = require("./styledComponents");
function getSideMenuOptions({ user, isLoadingUserSelectedTeam, userSelectedTeamData, isCompanySettingsVisible, isLoadingIsCompanySettingsVisible, teamId, }) {
    let userRole = '';
    if (!user || !Array.isArray(user?.roles) || isLoadingUserSelectedTeam || isLoadingIsCompanySettingsVisible) {
        return [];
    }
    const userSelectedTeam = userSelectedTeamData?.[0] || '';
    if (user?.roles && user?.roles.length === 1) {
        userRole = user?.roles[0]?.roleId || '';
    }
    else if (user?.roles.length > 1) {
        userRole = (0, userSelectors_1.isCompanyAdmin)(user?.roles)
            ? appConstants_1.overviewConstants.COMPANY_ADMIN
            : user?.roles.find(role => role.securityGroupId === userSelectedTeam)?.roleId || '';
    }
    return appConstants_1.sideMenuConstants
        .sideMenuOptions({
        isCompanySettingsVisible: Boolean(isCompanySettingsVisible),
        teamId: teamId || '',
    })
        .filter((option) => option.roles.includes(userRole));
}
function onButtonEvent({ isOpenOnDesktopView, isAsideOpen, openSideMenuOnDesktopView, isMobileWidth, openSideMenuOnMobileView, setIsAsideOpen, setOtherAsideOpen, }) {
    const shouldOpen = isOpenOnDesktopView && !isAsideOpen;
    openSideMenuOnDesktopView(!shouldOpen);
    if (isMobileWidth) {
        openSideMenuOnMobileView(true);
    }
    setIsAsideOpen(shouldOpen || !isAsideOpen);
    setOtherAsideOpen(false);
}
const useShowActivity = (userRoles, companyProperties) => {
    return (0, react_1.useMemo)(() => {
        if (!Array.isArray(userRoles) || !companyProperties) {
            return false;
        }
        if (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP) {
            return true;
        }
        if (!(0, userSelectors_1.isCompanyAdmin)(userRoles) || globalThis.config.IS_DEMO) {
            return true;
        }
        const showActivityValue = companyProperties.showactivity;
        return typeof showActivityValue !== 'object' && (showActivityValue === true || showActivityValue === 'true');
    }, [companyProperties, userRoles]);
};
const SideMenuPanel = () => {
    const theme = (0, material_1.useTheme)();
    const { isOpenOnDesktopView = true, isRequestAsideOpen, isTeamSwitcherAsideOpen, viewAllApprovals, openSideMenuOnDesktopView, openSideMenuOnMobileView, setIsOpenTeamSwitcherAside, setIsRequestAsideOpen, setTeam, setUiApprovals, setUiActivities, uiApprovals, uiActivities, } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        isOpenOnDesktopView: state.sideMenu.isOpenOnDesktopView,
        isRequestAsideOpen: state.aside.requestAside.isOpen,
        requestAside: state.aside.requestAside,
        isTeamSwitcherAsideOpen: state.sideMenu.isTeamSwitcherAsideOpen,
        viewAllApprovals: state.activity.viewAllApprovals,
        openSideMenuOnDesktopView: state.openSideMenuOnDesktopView,
        openSideMenuOnMobileView: state.openSideMenuOnMobileView,
        setIsOpenTeamSwitcherAside: state.setIsOpenTeamSwitcherAside,
        setIsRequestAsideOpen: state.setIsRequestAsideOpen,
        setTeam: state.setTeam,
        setUiApprovals: state.setUiApprovals,
        setUiActivities: state.setUiActivities,
        uiApprovals: state.approvals.list,
        uiActivities: state.activity.list,
    })));
    const { data: user } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: teams = [] } = (0, react_query_1.useQuery)((0, teamQuery_1.teamsQuery)({ state: 'active' }));
    const { data: userSelectedTeamData, isLoading: isLoadingUserSelectedTeam } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: currentTeam, isLoading: isGetCurrentTeamLoading } = (0, teamQuery_1.useGetCurrentTeamQuery)(teams, userSelectedTeamData);
    const { data: currentRole } = (0, rolesQuery_1.useGetRoleForUserQuery)(user, userSelectedTeamData?.[0] || '');
    const { data: approvalsData } = (0, react_query_1.useQuery)((0, approvalQuery_1.getCombinedApprovalsData)(user, userSelectedTeamData?.[0] || '', false));
    const { data: companyProperties } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(user?.companyAccountId, { showactivity: appConstants_1.companyPropertiesConstants.showactivity }));
    const showActivity = useShowActivity(user?.roles, companyProperties);
    const { data: activityData } = (0, react_query_1.useQuery)((0, approvalQuery_1.getCombinedApprovalsData)(user, userSelectedTeamData?.[0] || '', (0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles || []) ? true : viewAllApprovals));
    const navigate = (0, react_router_1.useNavigate)();
    const { data: isCompanySettingsVisible, isLoading: isLoadingIsCompanySettingsVisible } = (0, userQuery_1.useGetVerifyUserAccess)(access_1.composites.WRITE_COMPANY);
    const ref = (0, react_1.useRef)(null);
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const count = uiApprovals['pending']['count'] || 0;
    const activityCount = uiActivities['pending']['count'] || 0;
    (0, react_1.useEffect)(() => {
        if (approvalsData?.groupedApprovals) {
            setUiApprovals(approvalsData.groupedApprovals);
        }
    }, [approvalsData, setUiApprovals]);
    (0, react_1.useEffect)(() => {
        if (activityData?.groupedApprovals) {
            setUiActivities(activityData.groupedApprovals);
        }
    }, [activityData, setUiActivities]);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEmpty(currentTeam)) {
            setTeam(currentTeam);
        }
    }, [currentTeam, setTeam]);
    const onOptionClick = (0, react_1.useCallback)(({ route = '', name = '', isOpenOnDesktopView = true, isRequestAsideOpen = false, isTeamSwitcherAsideOpen = false, currentUser, }) => {
        const teamId = userSelectedTeamData?.[0] || '';
        if (route) {
            if (route === '/dashboard') {
                if ((0, userSelectors_1.isCompanyAdmin)(currentUser?.roles || []) || (0, userSelectors_1.isSupportAdmin)(currentUser?.roles || [])) {
                    void navigate('/dashboard');
                }
                else if (currentRole?.id === 'team_admin' || currentRole?.id === 'manager') {
                    void navigate(`dashboard/team/${teamId}`);
                }
            }
            else if (route === '/wallet' && !(0, userSelectors_1.isCompanyOrSupportAdmin)(currentUser?.roles || [])) {
                void navigate('/wallet/my-cards');
            }
            else if (route.startsWith('/teams') && route.endsWith('/manage-settlements')) {
                void navigate(`/teams/${teamId}/manage-settlements`);
            }
            else {
                void navigate(route);
            }
            setIsRequestAsideOpen(false);
            if (isMobileWidth) {
                openSideMenuOnMobileView(false);
            }
        }
        else if (name === strings_1.sideMenuStrings.SIDE_MENU_MY_REQUESTS_OPTION) {
            onButtonEvent({
                isOpenOnDesktopView,
                isAsideOpen: isRequestAsideOpen,
                openSideMenuOnDesktopView,
                isMobileWidth,
                openSideMenuOnMobileView,
                setIsAsideOpen: setIsRequestAsideOpen,
                setOtherAsideOpen: setIsOpenTeamSwitcherAside,
            });
        }
        else if (name === strings_1.sideMenuStrings.SIDE_MENU_TEAM_SWITCHER_OPTION) {
            onButtonEvent({
                isOpenOnDesktopView,
                isAsideOpen: isTeamSwitcherAsideOpen,
                openSideMenuOnDesktopView,
                isMobileWidth,
                openSideMenuOnMobileView,
                setIsAsideOpen: setIsOpenTeamSwitcherAside,
                setOtherAsideOpen: setIsRequestAsideOpen,
            });
        }
    }, [
        userSelectedTeamData,
        setIsRequestAsideOpen,
        isMobileWidth,
        navigate,
        currentRole?.id,
        openSideMenuOnMobileView,
        openSideMenuOnDesktopView,
        setIsOpenTeamSwitcherAside,
    ]);
    const isActiveOption = (0, react_1.useCallback)((route, option = { nestedRoute: '' }) => {
        const windowPathname = globalThis.location.pathname;
        const routeRegex = new RegExp(`^${route}(/|$)`);
        if (route === '') {
            // special case for empty paths which opens asides
            return windowPathname === option.nestedRoute;
        }
        return windowPathname === route || routeRegex.test(windowPathname) || windowPathname === option.nestedRoute;
    }, []);
    const linkClassNames = (0, react_1.useCallback)(option => (0, classnames_1.default)({
        'active-option': option?.route ? isActiveOption(option?.route, option) : isActiveOption('', option),
        link__collapsed: !isOpenOnDesktopView,
    }), [isActiveOption, isOpenOnDesktopView]);
    const sideMenuOptions = (0, react_1.useMemo)(() => getSideMenuOptions({
        user,
        userSelectedTeamData,
        isCompanySettingsVisible,
        isLoadingIsCompanySettingsVisible,
        isLoadingUserSelectedTeam,
        teamId: userSelectedTeamData?.[0],
    }), [
        isCompanySettingsVisible,
        isLoadingIsCompanySettingsVisible,
        user,
        userSelectedTeamData,
        isLoadingUserSelectedTeam,
    ]);
    const renderSideMenuOptions = (0, react_1.useCallback)(() => {
        if (!user) {
            return;
        }
        const menuItemClasses = option => (0, classnames_1.default)({
            expanded: isOpenOnDesktopView,
            collapsed: !isOpenOnDesktopView,
            hasApprovalIcon: (option.id === 'approvals' && Number(count) > 0) || (option.id === 'activity' && Number(activityCount) > 0),
            isMobileMenu: isMobileWidth,
        });
        const getIconClassNames = option => {
            return (option.id === 'approvals' && Number(count) > 0) || (option.id === 'activity' && Number(activityCount))
                ? 'hasApprovalIcon'
                : '';
        };
        const getIconWrapperClassNames = option => {
            return `${option.id === 'approvals' || option.id === 'activity' ? iconWrapper_1.StyledApprovalIconDisplayName : ''} ${isOpenOnDesktopView ? 'expanded' : 'collapsed'} ${isActiveOption('/support') ? 'active-icon' : ''}`;
        };
        const shouldRenderOption = option => {
            return !(option.id === 'activity' && !showActivity);
        };
        return sideMenuOptions.filter(shouldRenderOption).map(option => ((0, jsx_runtime_1.jsx)(StyledMenuItem_1.StyledMenuItem, { className: option.id === 'requests' && isRequestAsideOpen ? 'active-option' : linkClassNames(option), style: { padding: 0 }, "data-testid": option.id, onClick: () => onOptionClick({
                route: option.route,
                name: option.name,
                isOpenOnDesktopView,
                isRequestAsideOpen,
                isTeamSwitcherAsideOpen,
                currentUser: user,
            }), children: (0, jsx_runtime_1.jsxs)(styledComponents_1.StyledLink, { className: menuItemClasses(option), "data-testid": `sideMenu-${option.id}-btn`, "ts-variant": "sideMenuLink", "ts-data": `${option.id === 'approvals' || option.id === 'activity' ? String(option.id === 'approvals' ? (count > 49 ? '49+' : count) : activityCount > 49 ? '49+' : activityCount || 0) : null}`, children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: option.name, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: { lineHeight: 0.1 }, ref: ref, className: getIconClassNames(option), children: (0, jsx_runtime_1.jsx)(iconWrapper_1.default, { icon: () => {
                                    return globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { className: getIconWrapperClassNames(option), sx: {
                                            '& path:last-child': {
                                                fill: 'black !important',
                                            },
                                            marginTop: '8px',
                                            marginLeft: '5px',
                                            fill: 'black',
                                            filter: 'invert(1)',
                                        }, component: option.icon })) : ((0, jsx_runtime_1.jsx)(iconWrapper_1.default, { icon: option.icon, className: getIconWrapperClassNames(option) }));
                                }, className: getIconWrapperClassNames(option) }) }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", "ts-variant": "sideMenuItemSpan", sx: {
                            display: 'inline',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '70vw',
                        }, children: option.name }), (0, jsx_runtime_1.jsx)(ArrowForwardIos_1.default, { style: {
                            opacity: `${option.hasAside && isOpenOnDesktopView ? 1 : 0}`,
                            transition: 'opacity 0.3s ease-in-out',
                        }, "ts-variant": "teamSwitcherArrowIcon" })] }) }, option.id)));
    }, [
        user,
        sideMenuOptions,
        isOpenOnDesktopView,
        count,
        activityCount,
        isMobileWidth,
        isActiveOption,
        showActivity,
        isRequestAsideOpen,
        linkClassNames,
        onOptionClick,
        isTeamSwitcherAsideOpen,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", style: {
                    backgroundColor: 'hsl(205, 20%, 30%)',
                    fontWeight: 350,
                    fontSize: isOpenOnDesktopView ? theme.typography.tsFontSize.default : 0,
                    color: 'white',
                    paddingLeft: '18px',
                    paddingBottom: '10px',
                    whiteSpace: 'nowrap',
                }, children: "Business Virtual Cards" })) : null, (0, jsx_runtime_1.jsxs)(material_1.Paper, { "data-testid": "sideMenu-panel", "ts-variant": "sideMenuPanel", onClick: event => {
                    event.preventDefault();
                    if (event.target === event.currentTarget) {
                        // only if we click in the sideMenuPanel body,
                        // we want to trigger this event; otherwise it gets triggered
                        // when we click on menu options also
                        openSideMenuOnDesktopView(!isOpenOnDesktopView);
                    }
                }, style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: `calc(100vh - ${theme.tsGoUnit.tsUnitTriple}px - ${theme.tsGoUnit.tsUnitTriple}px)`,
                    overflow: 'hidden auto',
                    gap: theme.tsGoUnit.tsUnitDouble,
                    scrollbarWidth: 'thin',
                }, children: [(0, jsx_runtime_1.jsxs)(material_1.MenuList, { children: [renderSideMenuOptions(), (0, jsx_runtime_1.jsx)(createNewRequestButton_1.default, {})] }), (0, jsx_runtime_1.jsxs)(material_1.MenuList, { "ts-variant": "supportMenu", children: [!isGetCurrentTeamLoading &&
                                !(0, userSelectors_1.isCompanyAdmin)(user?.roles || []) &&
                                !isCompanySettingsVisible &&
                                teams.length > 1 && ((0, jsx_runtime_1.jsx)(StyledMenuItem_1.StyledMenuItem, { className: isTeamSwitcherAsideOpen ? 'active-option' : linkClassNames(''), style: { padding: 0, display: 'block' }, children: (0, jsx_runtime_1.jsxs)(material_1.Link, { "data-testid": "sideMenu-teamSwitcher-btn", "ts-variant": "sideMenuLink", onClick: () => onOptionClick({
                                        route: '',
                                        name: strings_1.sideMenuStrings.SIDE_MENU_TEAM_SWITCHER_OPTION,
                                        isTeamSwitcherAsideOpen,
                                        currentUser: user,
                                    }), children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: 'Team Switcher', children: (0, jsx_runtime_1.jsx)(material_1.Typography, { ref: ref, children: (0, jsx_runtime_1.jsx)(iconWrapper_1.default, { icon: () => globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { sx: {
                                                            '& path:last-child': {
                                                                fill: 'black !important',
                                                            },
                                                            marginTop: '8px',
                                                            marginLeft: '5px',
                                                            filter: 'invert(1)',
                                                        }, component: ContactLiveChatActive_1.default })) : ((0, jsx_runtime_1.jsx)(People_1.default, {})), className: `${isOpenOnDesktopView ? 'expanded' : 'collapsed'} ${isActiveOption('/support') ? 'active-icon' : ''}` }) }) }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", "ts-variant": "multiLine", style: { marginLeft: '-30px' }, children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: currentTeam?.name || '', children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "roleNameSwitcher", children: currentTeam?.name || '' }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", "ts-variant": "secondary", style: {
                                                        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                                            ? {
                                                                color: '#ffffff',
                                                            }
                                                            : {}),
                                                    }, children: currentRole?.label })] }), (0, jsx_runtime_1.jsx)(ArrowForwardIos_1.default, { style: {
                                                opacity: Number(isOpenOnDesktopView),
                                                transition: 'opacity 0.3s ease-in-out',
                                            }, "ts-variant": "teamSwitcherArrowIcon" })] }) }, 'Team Switcher')), (0, jsx_runtime_1.jsx)(StyledMenuItem_1.StyledMenuItem, { className: linkClassNames('/support'), style: { padding: 0 }, children: (0, jsx_runtime_1.jsxs)(material_1.Link, { "ts-variant": "sideMenuLink", onClick: () => {
                                        void navigate('/support');
                                    }, children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: 'Support', children: (0, jsx_runtime_1.jsx)(material_1.Typography, { ref: ref, style: {
                                                    display: 'flex',
                                                }, children: (0, jsx_runtime_1.jsx)(iconWrapper_1.default, { icon: () => globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { sx: {
                                                            '& path:last-child': {
                                                                fill: 'black !important',
                                                            },
                                                            marginTop: '8px',
                                                            marginLeft: '5px',
                                                            filter: 'invert(1)',
                                                        }, component: ContactLiveChatActive_1.default })) : ((0, jsx_runtime_1.jsx)(Support_1.default, {})), className: `${isOpenOnDesktopView ? 'expanded' : 'collapsed'} ${isActiveOption('/support') ? 'active-icon' : ''}` }) }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", "ts-variant": "sideMenuItemSpan", sx: {
                                                display: 'inline',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '70vw',
                                            }, children: strings_1.sideMenuStrings.SUPPORT })] }) }, 'Support')] })] })] }));
};
exports.default = SideMenuPanel;
